<template>
  <div class="col-12 buddyOverlay">
    <div class="buddyOverlayContent">
      <div class="top-bar">
        <button class="btn home-button" @click="backClicked" :class="{hide : hideButtons}" v-hover="onHoverOverHome">
          <span class="icon"></span>
        </button>
        <div v-if="name!== null && name !== '' " class="buddy-name-bar"><p>{{ name }}</p>
          <p class="level">level {{ level || 0 }}</p>
        </div>
        <div class="top-bar-buttons">
          <button class="btn leaderboard-button" :class="{hide : hideButtons}" v-on:click="leaderboardClicked"
                  v-hover="onHoverOverLeaderboard">
            <span class="icon"></span>
          </button>
          <button class="btn clothes-button" :class="{hide : hideButtons}" v-on:click="clothesClicked"
                  v-hover="onHoverOverAccessories">
            <span class="icon"></span>
          </button>
        </div>
      </div>
      <div class="buttons">
        <div class="buttons-left" v-show="!hideButtons">
          <ActivityButton :name="'more'" :show="!hideButtons"
                          :startedActivities="getActivitiesByType(startedActivities, 'more')"
                          :plannedActivities="getActivitiesByType(plannedActivities, 'more')"
                          v-on:clicked="activityButtonClicked"
                          v-on:nextPlannedActivityClicked="nextPlannedActivityClicked"
                          v-on:notificationClicked="notificationClicked"></ActivityButton>
          <ActivityButton :name="'smart'" :show="!hideButtons"
                          :startedActivities="getActivitiesByType(startedActivities, 'smart')"
                          :plannedActivities="getActivitiesByType(plannedActivities, 'smart')"
                          v-on:clicked="activityButtonClicked"
                          v-on:nextPlannedActivityClicked="nextPlannedActivityClicked"
                          v-on:notificationClicked="notificationClicked"></ActivityButton>

        </div>
        <div class="center">

        </div>
        <div class="buttons-right" v-show="!hideButtons">
          <ActivityButton :name="'together'" :show="!hideButtons"
                          :startedActivities="getActivitiesByType(startedActivities, 'together')"
                          :plannedActivities="getActivitiesByType(plannedActivities, 'together')"
                          v-on:clicked="activityButtonClicked"
                          v-on:nextPlannedActivityClicked="nextPlannedActivityClicked"
                          v-on:notificationClicked="notificationClicked"></ActivityButton>
          <ActivityButton :name="'impulse'" :show="!hideButtons"
                          :startedActivities="getActivitiesByType(startedActivities, 'impulse')"
                          :plannedActivities="getActivitiesByType(plannedActivities, 'impulse')"
                          v-on:clicked="activityButtonClicked"
                          v-on:nextPlannedActivityClicked="nextPlannedActivityClicked"
                          v-on:notificationClicked="notificationClicked"></ActivityButton>
        </div>
      </div>
    </div>
    <HoverInfo :show="hoveringOverHome" :content="'Ga terug naar het leerkrachtenplatform'" :offset-y="12"
               :offset-x="12"></HoverInfo>
    <HoverInfo :show="hoveringOverAccesories" :content="'Laat je buddy nieuwe attributen passen'" :offset-y="12"
               :offset-x="12"></HoverInfo>
    <HoverInfo :show="hoveringOverLeaderboard" :content="'Open het klassement'" :offset-y="12"
               :offset-x="12"></HoverInfo>
    <HoverInfo :show="hoveringOverMore"
               :content="'Klik hier om alle opdrachten van de categorie \'Beweeg Meer\' te zien'" :offset-y="12"
               :offset-x="12"></HoverInfo>
    <HoverInfo :show="hoveringOverSmart"
               :content="'Klik hier om alle opdrachten van de categorie \'Beweeg Slim\' te zien'" :offset-y="12"
               :offset-x="12"></HoverInfo>
    <HoverInfo :show="hoveringOverTogether"
               :content="'Klik hier om alle opdrachten van de categorie \'Beweeg Samen\' te zien'" :offset-y="12"
               :offset-x="12"></HoverInfo>
    <HoverInfo :show="hoveringOverImpulse"
               :content="'Klik hier om alle opdrachten van de categorie \'Beweeg Tussendoor\' te zien'" :offset-y="12"
               :offset-x="12"></HoverInfo>
  </div>
</template>

<script>

import log from "@/utils/logger";
import ActivityButton from "@/components/StudentPlatform/BuddyInfoOverlay/ActivityButton";
import HoverInfo from "@/components/UI/HoverInfo.vue";

export default {
  name: "BuddyInfoOverlay",
  components: {HoverInfo, ActivityButton},
  props: {
    hideButtons: Boolean,
    name: String,
    level: Number,
    startedActivities: Array,
    plannedActivities: Array,
  },
  data() {
    return {
      hoveringOverHome: false,
      hoveringOverMore: false,
      hoveringOverSmart: false,
      hoveringOverTogether: false,
      hoveringOverImpulse: false,
      hoveringOverAccesories: false,
      hoveringOverLeaderboard: false,
    }
  },
  computed: {},
  mixins: [],
  methods: {
    clothesClicked() {
      if (!this.$el.querySelector('.clothes-button').classList.contains('hide')) {
        this.$emit("clothesClicked");
      }
    },
    leaderboardClicked() {
      if (!this.$el.querySelector('.leaderboard-button').classList.contains('hide')) {
        this.$emit("leaderboardClicked");
      }
    },
    activityButtonClicked(data) {
      log.debug(data);
      this.$emit("activityButtonClicked", data);
    },

    nextPlannedActivityClicked(name) {
      this.$emit("nextPlannedActivityClicked", {
        name: name,
        id: this.getActivitiesByType(this.plannedActivities, name)[0].id
      });
    },

    notificationClicked(name) {
      log.debug(name);
      this.$emit("notificationClicked", name);
    },

    getActivitiesByType(activities, type) {
      let filteredActivities = [];
      if (activities) {
        activities.forEach(activity => {
          if (activity.quest.type === type) {
            filteredActivities.push(activity);
          }
        });
      }

      return filteredActivities;
    },

    backClicked() {
      this.$router.push({name: 'agenda'});
    },
    onHoverOverHome(state) {
      this.hoveringOverHome = state;
    },
    onHoverOverMore(state) {
      this.hoveringOverMore = state;
    },
    onHoverOverSmart(state) {
      this.hoveringOverSmart = state;
    },
    onHoverOverTogether(state) {
      this.hoveringOverTogether = state;
    },
    onHoverOverImpulse(state) {
      this.hoveringOverImpulse = state;
    },
    onHoverOverAccessories(state) {
      this.hoveringOverAccesories = state;
    },
    onHoverOverLeaderboard(state) {
      this.hoveringOverLeaderboard = state;
    }

  }
}


</script>

<style lang="scss" scoped>

@mixin aspect-ratio($width, $height) {
  position: relative;
  &:before {
    display: block;
    content: "";
    width: 100%;
    padding-top: ($height / $width) * 100%;
  }
  > .content {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
  }
}

.buddyOverlay, .buddyCustomisationOverlay {
  //height: calc(100vh - 75px - 50px);

  height: min(100vh, calc(100vw * 0.5625));

  //overflow: hidden;
  position: absolute;
  top: 0px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  pointer-events: none;
  will-change: transform;

  .buddyOverlayContent {
    width: min(100vw, calc(100vh * 1.77777));
    padding: 0px 50px;
    height: 90%;

    .top-bar {
      height: 15%;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: stretch;

      .top-bar-buttons {
        display: flex;
        flex-direction: row;
        justify-content: flex-end;
        height: 100%;
        width: 18%;

        .btn {
          width: 50%;
        }
      }


      .buddy-name-bar {
        width: 40%;
        display: flex;
        justify-content: center;
        align-items: center;
        background-image: url("~@/assets/image/platform/frame-level.svg");
        background-repeat: no-repeat;
        background-position: center;
        background-size: contain;
        flex-direction: column;

        p {
          font-size: min(3vw, 4vh);
          font-weight: bold;
          color: white;
          margin-bottom: 0px;
          margin-top: 0px;
          height: 50%;

          &.level {
            font-size: min(2vw, 3vh);
            height: 30%;
          }
        }
      }

      .btn {
        width: 10%;
        height: 100%;
        background-image: url("~@/assets/image/bb_button_square.svg");
        background-repeat: no-repeat;
        background-position: center;
        pointer-events: all;
        display: flex;
        justify-content: center;
        align-items: center;

        &.hide {
          visibility: hidden;
          pointer-events: none;
        }
      }

      .clothes-button {
        .icon {
          width: 70%;
          height: 70%;
          background-image: url("~@/assets/image/bb_icon-customize.svg");
          background-repeat: no-repeat;
          background-position: center;
        }
      }

      .leaderboard-button {
        .icon {
          width: 65%;
          height: 65%;
          background-image: url("~@/assets/image/icons/icon_leaderboard.svg");
          background-repeat: no-repeat;
          background-position: center;
        }
      }

      .home-button {
        .icon {
          width: 70%;
          height: 70%;
          background-image: url("~@/assets/image/bb_icon-home.svg");
          background-repeat: no-repeat;
          background-position: center;
        }
      }
    }

    .buttons {
      display: flex;
      height: 85%;

      .buttons-left, .buttons-right {
        height: 100%;
        width: 26%;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        //padding-bottom: 8%;
        //padding-top: 3%;

        .activity-button {
          margin-bottom: 10px;
          //background-image: url("~@/assets/image/bb_button_activity.svg");
          background-repeat: no-repeat;
          background-position: center;
          height: 50%;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          padding: 10%;
          position: relative;

          &.more .cls-7 {
            fill: rgb(255, 90, 49);
          }

          &.smart .cls-7 {
            fill: rgb(0, 185, 255);
          }

          &.together .cls-7 {
            fill: rgb(159, 220, 96);
          }

          &.impulse .cls-7 {
            fill: rgb(253, 132, 255);
          }

          .bg {
            position: absolute;
            width: 100%;
            height: 100%;
            z-index: -1;
          }

          .icon {
            width: 70%;
            height: 70%;
            background-repeat: no-repeat;
            background-position: center;
          }

          .title {
            font-size: min(3vw, 3vh);
            line-height: 0.9;
            font-weight: bold;
            color: white;
            text-align: center;
          }

          .notification {
            position: absolute;
            top: -5%;
            right: -5%;
            width: 30%;
            height: 30%;
            display: flex;
            justify-content: center;
            align-items: center;

            svg {
              position: absolute;
              z-index: -1;
            }

            span {
              font-weight: bold;
              color: white;
              font-size: min(4vh, 4vw);
            }
          }
        }
      }

      .center {
        height: 100%;
        width: 68%;
      }
    }

    .center {
      pointer-events: none;
      margin: 0 auto;

      .level {
        display: flex;
        flex-direction: column;
        padding: 1%;

        width: 7%;
        height: 11%;
        position: absolute;
        //left: 25vw;
        bottom: 19%;
        margin-left: 15px;

        background-image: url("~@/assets/image/bb_button_square.svg");
        background-repeat: no-repeat;
        background-position: center;
        display: flex;
        justify-content: center;
        align-items: center;

        .level-label {
          top: 5px;
          position: absolute;
          font-size: min(2vw, 2vh);
        }

        .level-value {
          position: absolute;
          font-size: min(2vw, 3vh);
        }

        p {
          font-size: min(5vw, 5vh);
          font-weight: bold;
          color: white;
          margin-bottom: 0px;
          margin-top: 0px;
        }
      }
    }
  }


}

.one-one {
  @include aspect-ratio(1, 1);
}
</style>